import { createFileRoute } from '@tanstack/react-router';
import { findNavItem } from '@/shared/patterns/AppShell';
import { collectionsNav } from '@/domains/collections';
import { UnderConstruction } from '@/shared/components/UnderConstruction';

// Catch-all temporal: cada item del sidebar cae aquí hasta que su pantalla real lo reemplace.
export const Route = createFileRoute('/_backoffice/collections/$section')({
    component: CollectionsSection,
});

function CollectionsSection() {
    const { section } = Route.useParams();
    return <UnderConstruction title={findNavItem(collectionsNav, section)?.label ?? section} />;
}
